.system-messages-component {
  display: flex;
  flex-direction: column;
}
.map-view .system-messages-component {
  padding: 0 20px;
}
/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VSb290IjoiL29wdC9zcmMvc2NyaXB0L2NvbXBvbmVudHMvU3lzdGVtTWVzc2FnZXMiLCJzb3VyY2VzIjpbIlN5c3RlbU1lc3NhZ2VzLnNjc3MiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBQUE7RUFDRTtFQUNBOztBQUVBO0VBQ0UiLCJzb3VyY2VzQ29udGVudCI6WyIuc3lzdGVtLW1lc3NhZ2VzLWNvbXBvbmVudCB7XG4gIGRpc3BsYXk6IGZsZXg7XG4gIGZsZXgtZGlyZWN0aW9uOiBjb2x1bW47XG5cbiAgLm1hcC12aWV3ICYge1xuICAgIHBhZGRpbmc6IDAgMjBweDtcbiAgfVxufVxuIl19 */